import { render } from "./parola-sifirla.vue?vue&type=template&id=7023e9b9"
import script from "./parola-sifirla.vue?vue&type=script&lang=js"
export * from "./parola-sifirla.vue?vue&type=script&lang=js"

import exportComponent from "/home/B2BServer/b2bPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__